import { ComponentStyleConfig } from "@chakra-ui/react";

const PopoverTheme: ComponentStyleConfig = {
  parts: ["popper", "content"],
  baseStyle: {
    popper: {
      // default zIndex value is "10" for some reason
      zIndex: "popover",
    },
    content: {
      shadow: "xl",
      _focusVisible: {
        boxShadow: "none",
      },
      "&&": {
        borderWidth: "1px",
        borderColor: "gray.100",
        borderStyle: "solid",
      },
    },
  },
};

export default PopoverTheme;
